import { Link } from "react-router-dom";
import Layout from "@/components/site/Layout";

export default function NotFound() {
  return (
    <Layout>
      <div className="flex items-center justify-center pt-[74px]">
        <div className="container-lp text-center py-32">
          <p className="font-heading font-700 text-lp-cyan text-8xl">404</p>
          <h1 className="font-heading font-700 text-lp-blue text-3xl md:text-4xl mt-4">Page Not Found</h1>
          <p className="text-lp-muted mt-4 max-w-md mx-auto">The page you are looking for may have moved or no longer exists.</p>
          <Link to="/" data-testid="notfound-home" className="inline-block mt-8 bg-lp-blue text-white font-600 px-8 py-3.5 rounded-sm hover:bg-lp-steel transition-colors">Back to Home</Link>
        </div>
      </div>
    </Layout>
  );
}
